import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './ChiSiamo.css';

class ChiSiamo extends Component {
    render() {
        return (
            <Grid item xs={12} id='who'>
                <Grid container>
                    <Grid item xs={12}>
                        <h1 className='slide-title'>Chi Siamo</h1>
                    </Grid>
                    <Grid item xs={12}>
                        <div className='slogan'>
                            <p>Forniamo servizi tecnici professionali a Roma</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container>
                            <Grid item xs={12} className='chi-siamo'>
                                <div className='who-text'>
                                    <p>
                                        Radio Gaga si avvale di personale tecnico competente ed altamente specializzato, in
                                        grado di operare con la massima efficienza e teso ad una continua crescita
                                        professionale conseguita tramite un piano di formazione in continua evoluzione
                                        grazie al supporto ed all'affiancamento tecnico dei costruttori rappresentati, quali
                                        Alcatel, Alpine, H3G, Humax, LG, Loewe, Pioneer, TELE System, Philips.
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} className='chi-siamo'>
                                <div className='who-text'>
                                    <p>L'elevata qualità della strumentazione permette di eseguire, sugli apparati, tarature ed analisi funzionali con la massima precisione. </p>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container>
                            <Grid item xs={12} className='chi-siamo'>
                                <div className='who-text'>
                                    <p>
                                        Il laboratorio è strutturato per poter eseguire qualsiasi livello di riparazione grazie all'utilizzo di apparecchiature professionali ed applicando metodologie
                                        precauzionali quali pavimenti, tappeti e bracciali antistatici (protezione ESD - Electric Static Device).
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} className='chi-siamo'>
                                <div className='who-text'>
                                    <p>
                                        Radio Gaga attua un processo interno di lavorazione che viene costantemente monitorato tramite una rete informatica altamente efficace e continuamente
                                        aggiornata e migliorata. Questa metodologia consente un controllo globale, dall'accettazione del prodotto all'analisi e gestione di tutte le fasi
                                        produttive nonchè dei rapporti con l'utente finale, ma soprattutto con i centri autorizzati e di raccolta a noi affiliati.
                                    </p>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        );
    }
}

export default ChiSiamo;